import { useLabels } from "@teamna/web-client/hooks/use-labels.ts";
import { useOwnerBusiness } from "@teamna/web-client/hooks/use-owner.ts";
import { useUpdateBusiness } from "@teamna/web-client/hooks/use-setup.ts";
import { InlineError, ToggleRow, showToast } from "../components/index.ts";

/**
 * "Approve each cover" (Pilates studio shape S3), a switch in the Rules block of the Staff page (one block since the redesign of 2026-11-03). Off (the default): the first
 * staff member who says yes runs the session at once. On: the yes waits for the owner or an admin,
 * on the session panel and in To do. The switch sends nothing.
 */
export function CoverRuleRow({ businessId }: { businessId: string }) {
  const { label } = useLabels();
  const business = useOwnerBusiness(businessId);
  const update = useUpdateBusiness(businessId);
  const staff = label("staff");
  const staffPlural = label("staff", { plural: true });
  const on = business.data?.settings.coverNeedsApproval === true;
  return (
    <>
      <ToggleRow
        label="Approve each cover"
        hint={`A ${staff} who cannot run a session asks for cover in the app, and the other ${staffPlural} of the class get a push. ${
          on
            ? `On: a yes waits for you. Until you approve, the ${staff} who asked stays on the session.`
            : `Off: the first ${staff} who says yes runs the session at once. You get a push.`
        }`}
        checked={on}
        disabled={update.isPending || !business.data}
        onChange={(next) =>
          update.mutate(
            { settings: { coverNeedsApproval: next } },
            { onSuccess: () => showToast(next ? "You approve each cover from now on." : "The first yes takes the session from now on.") },
          )
        }
      />
      {update.error ? <InlineError error={update.error} /> : null}
    </>
  );
}
